/** Application navigation links */
export const appLinks = {
  home: "/",
  about: "/about",
  faq: "/faq",
  contact: "/contact",
  cgu: "/cgu",
  privacy: "/privacy",
  login: "/auth/login",
  signup: "/auth/signup",
  account: {
    ROOT: "/account",
    PROFILE: "/account/profile",
    CARDS: "/account/cards",
    CHAT: "/account/chat",
    HISTORY: "/account/history",
    MEMORY: "/account/memory",
    CONTACT: "/account/contact",
    INSTRUCTIONS: "/account/instructions",
    REFILL: "/account/refill",
    SETTINGS: "/account/settings",
    STUDIO: "/account/studio",
    VOICE_AGENT: "/account/voice-agent",
    ORIENTATION: "/account/orientation",
    MY_PROMPTS: "/account/my-prompts",
    DATA_CONTROLS: "/account/settings/data",
    BILLING_INFO: "/account/settings/billing-info",
  },
  admin: {
    ROOT: "/admin",
    DASHBOARD: "/admin/dashboard",
    USERS: "/admin/users",
    SETTINGS: "/admin/settings",
  },
} as const

export type AppLinks = typeof appLinks
